import { getMessaging, getToken } from "firebase/messaging";
import { STORAGE_KEYS } from "../constants/storageKeys";
import app from "./firebaseKeys";
import { getFromStorage, setToStorage } from "../helpers";

const firebaseCloudMessaging = {
   
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BI8brfD3eIFGtlXSZUQ6YuiL-AHdsfnK2NazOeWrtgRFQyh_ejp5cyhM8hfvlcCNr-oC3W_T8CdZBMQZGp175Kg",
        });

        if (fcm_token) {

          await setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      }
    } catch{
      return null;
    }
  },
};

export { firebaseCloudMessaging };
